import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { ListingCard } from "@/components/Listings";

export default function Favorites() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [favs, setFavs] = useState([]);

  useEffect(() => { if (!loading && !user) navigate("/login"); }, [loading, user, navigate]);

  useEffect(() => {
    if (!user) return;
    api.get("/me/favorites").then(({ data }) => {
      setItems(data);
      setFavs(data.map((l) => l.listing_id));
    });
  }, [user]);

  const toggleFav = async (id) => {
    await api.delete(`/listings/${id}/favorite`);
    setItems((p) => p.filter((l) => l.listing_id !== id));
    setFavs((p) => p.filter((x) => x !== id));
  };

  if (!user) return null;

  return (
    <div className="max-w-[1400px] mx-auto px-4 md:px-8 mt-8" data-testid="favorites-page">
      <h1 className="font-display text-3xl md:text-5xl uppercase border-b-2 border-black pb-2">/ Favorites</h1>
      <div className="font-mono-data text-xs uppercase mt-1 text-gray-600">{items.length} saved listing(s)</div>

      {items.length === 0 ? (
        <div className="border-2 border-black p-12 text-center font-mono-data text-sm uppercase text-gray-500 mt-6">No favorites yet. Heart items to save them.</div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-6">
          {items.map((l) => <ListingCard key={l.listing_id} listing={l} isFavorite={favs.includes(l.listing_id)} onToggleFavorite={toggleFav} />)}
        </div>
      )}
    </div>
  );
}
